<div class="d-flex gap-2 align-items-center">
  <label class="mb-0 cursor-pointer user-select-none" [for]="inputId()">{{ label() }}</label>
  <p-toggleswitch [inputId]="inputId()" [(ngModel)]="value" />
</div>
